import { styled, TableFooter as MuiTableFooter } from '@mui/material';

export const TableFooter = styled(MuiTableFooter)({
  display: 'flex',
  flexDirection: 'row-reverse',
});
